import React from 'react';
import identity from 'lodash/identity';

import './Label.less';

/**
 *
 * @param {{
 *  hide?: boolean;
 *  required?: boolean;
 *  htmlFor?: string;
 *  text?: React.ReactNode;
 *  children?: React.ReactNode|React.ReactNode[];
 *  className?: string;
 *  id?: string;
 * }} props
 * @returns {React.ReactElement|null}
 */
export const Label = props => {
  const { required, id, htmlFor, text = '', className = '', hide = false, children } = props;

  return hide ? null : (
    <label className={["lsn-control-label", className].filter(identity).join(' ')} htmlFor={htmlFor} {...{ id }}>
      {required ? <span className="lsn-required-tag">*</span> : null}
      {text}
      {children}
    </label >
  );
};

export default Label;
